import React from 'react'

export const formatBoldChunks = (chunks) => <b className="text-bold">{chunks}</b>
